export const openSideDrawer = (open) => {
    return {
        type: 'SIDE_DRAWER',
        payload: open
    }
};



// WEBPACK FOOTER //
// ./src/scenes/Login/components/ApplicationBar/components/ToolBar/components/NavIcon/actions.js